(function(angular){
	'use strict';

	angular
		.module('authModule')
		.controller('additionalResetQuestionsTrustController', [
			'$timeout',
			'globalConfig',
			'urlFactory',
			AdditionalResetQuestionsTrustController
		]);

	function AdditionalResetQuestionsTrustController(
		$timeout,
		globalConfig,
		urlFactory
	){
		var additionalResetQuestionsTrust = this;

		additionalResetQuestionsTrust.$onInit = function() {
			angular.extend(additionalResetQuestionsTrust, globalConfig);
			
			if(angular.isDefined(additionalResetQuestionsTrust.serverSideErrorMap)) {
				$timeout(function() {
					urlFactory.handleServerValidation(
						additionalResetQuestionsTrust.additionalResetQuestionsTrustForm,
						urlFactory.spoofApiError(additionalResetQuestionsTrust.serverSideErrorMap)
					);
				}, 100);
			}
		};
	}
})(window.angular);